import { useContext, useEffect } from 'react';
import PaymentsEmbedPointContextProvider from 'payments-embed-points-lib/context/PaymentsEmbedPointContextProvider';
import PaymentsEmbedPointContext from 'payments-embed-points-lib/context/PaymentsEmbedPointContext';
import { Screen } from 'payments-embed-points-lib/types/screen';
import { jsx as _jsx } from "react/jsx-runtime";
function ChildComponent() {
  const {
    getPaymentsInterstitialModalOpenHandler
  } = useContext(PaymentsEmbedPointContext);
  useEffect(() => {
    const openPaymentsModal = getPaymentsInterstitialModalOpenHandler();
    openPaymentsModal();
  }, [getPaymentsInterstitialModalOpenHandler]);
  return null;
}
export default function PaymentsUpgradeModal() {
  return /*#__PURE__*/_jsx(PaymentsEmbedPointContextProvider, {
    screen: Screen.WORKFLOWS,
    children: /*#__PURE__*/_jsx(ChildComponent, {})
  });
}